export const AUTHENTICATION = 'authentication';
export const SETTINGS = 'settings';
export const EXECUTION = 'execution';
export const REFRESH_CREDENTIALS = 'refresh_credentials';
export const ENABLE_INTEGRATION = 'enable_integration';
export const IAD_CANCEL_BTN_CLICK = 'iad_cancel_btn_click';
export const IAD_SAVE_BTN_CLICK = 'iad_save_btn_click';
export const TEST_CONNECTION = 'test_connection';
export const DESTINATION = 'destination';